import type { TicketStatus } from '@beacon/core';
import { Badge, type BadgeTone } from '@/components/ui/badge.js';

const toneByStatus: Record<TicketStatus, BadgeTone> = {
  new: 'blue',
  triaged: 'slate',
  in_progress: 'violet',
  awaiting_client: 'yellow',
  resolved: 'green',
  closed: 'slate',
};

const labelByStatus: Record<TicketStatus, string> = {
  new: 'New',
  triaged: 'Triaged',
  in_progress: 'In progress',
  awaiting_client: 'Awaiting client',
  resolved: 'Resolved',
  closed: 'Closed',
};

export function Status({ s }: { s: TicketStatus }) {
  return (
    <Badge tone={toneByStatus[s]} dot>
      {labelByStatus[s]}
    </Badge>
  );
}
